import { render, staticRenderFns } from "./PartnershipC.vue?vue&type=template&id=261b21dc&scoped=true"
import script from "./PartnershipC.vue?vue&type=script&lang=js"
export * from "./PartnershipC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b21dc",
  null
  
)

export default component.exports